module.exports = __webpack_public_path__ + "media/photo/testi-bb9b195a.png";